import { authHeader } from '../_helpers';
import { handleResponse } from '../_helpers';

import { apiClient } from '../_helpers';

export const userService = {
    setToken,
    forgotPassword,
    login,
    logout,
    register,
    addUser,
    getAll,
    getSelectList,
    getInfo,
    resetPassword,
    update,
    getAccessTasks,
    respondToAccessTask,
    deleteUser,
    isLoggedIn
};

function login(email, password, clientId) {
  const user = {
    "email": email,
    "password": password,
    "clientId": clientId
  }
  const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(user)
  };
  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/users/authenticate`, requestOptions)
      .then(handleResponse)
      .then(resp => {
        localStorage.setItem('user', JSON.stringify(resp));
        return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/users/${resp.user.id}`, {
          method: 'GET',
          headers: authHeader(),
        })
        .then(handleResponse)
        .then(user => {
          resp.user = user;
          localStorage.setItem('user', JSON.stringify(resp));
          localStorage.setItem('version', process.env.VUE_APP_API_HOSTNAME + ' - ' + resp.version)
          return resp;
        })
        .catch(error => {
          return Promise.reject(error);
          console.error("There was an error!", error);
        });
      })
      .then(resp => {
          // login successful if there's a jwt token in the response
          if (resp.token) {
              return resp;
          }
      });
}
function setToken(resp) {

          localStorage.setItem('user', JSON.stringify(resp));
          return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/users/${resp.user.id}`, {
            method: 'GET',
            headers: authHeader(),
          })
          .then(handleResponse)
          .then(user => {
            resp.user = user;
            localStorage.setItem('user', JSON.stringify(resp));
            localStorage.setItem('version', process.env.VUE_APP_API_HOSTNAME + ' - ' + resp.version)
            return resp;
          })
          .catch(error => {
            return Promise.reject(error);
            console.error("There was an error!", error);
          });

}
function register(user) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };
    return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/users`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
            }

            return user;
        })
        .catch(error => {
          return Promise.reject("User was already found.");
          console.error("There was an error!", error);
        });
}

async function addUser(user) {
  try {
    const response = await apiClient('users')
      .post('', `${JSON.stringify(user)}`);
    return response.data;
  } catch (error) {
    return error;
  }
}

let loggingOut = false;

export function logout() {
    if (loggingOut) return;
    loggingOut = true;
    //store.commit('authentication/logout');
    window.localStorage.clear();
    window.location.href = '/login'; // safest option
}

function isLoggedIn() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/users/loggedin`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    });
}

function getInfo(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/users/${id}`, requestOptions)
        .then(handleResponse)
        .then(user => {
          return user;
        });
}
function getAll(params) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    var ps = "";
    var ccat = "";
    if( params && params.query)
    {
      ps = ps + "searchQuery=" + params.query;
      ccat = "&";
    }
    if( params && params.pageSize )
    { 
      ps = ps + ccat + "pageSize=" + params.pageSize;
      ccat = "&";
    }
    if( params && params.page )
    {
      ps = ps + ccat + "pageNumber=" + params.page;
      ccat = "&";
    }

    return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/users?${ps}`, requestOptions).then(handleResponse);
}
function getSelectList() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/users/selectlist`, requestOptions).then(handleResponse);
}

function update(user) {
  const requestOptions = {
      method: 'PUT',
      headers: authHeader(),
      body: JSON.stringify(user)
  };

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/users/${user.id}`, requestOptions).then(handleResponse);
}

async function deleteUser(userId) {
  const requestOptions = {
      method: 'DELETE',
      headers: authHeader()
  };

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/users/${userId}`, requestOptions).then(handleResponse);
}

function getAccessTasks() {
  const requestOptions = {
      method: 'GET',
      headers: authHeader()
  };

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/users/accesstasks`, requestOptions).then(handleResponse);
}

function respondToAccessTask(accessTask) {
  const requestOptions = {
      method: 'POST',
      headers: authHeader(),
      body: JSON.stringify(accessTask)
  };

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/users/accesstasks`, requestOptions).then(handleResponse);
}

function forgotPassword(params) {
  const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params)
  };

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/users/forgotpassword`, requestOptions).then(handleResponse);
}

function resetPassword(params) {
  const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params)
  };

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/users/resetpassword`, requestOptions).then(handleResponse);
}